import { t } from '@unistocks/shared/localization/index.ts';
import { toast } from 'sonner';

export const showErrorToast = (error: unknown) => {
  const message = resolveErrorMessage(error);
  toast.error(message);
};

export const resolveErrorMessage = (error: unknown): string => {
  if (error && typeof error === 'object' && 'error' in error) {
    const abpError = error as AbpErrorResponse;
    return abpError.error.message ?? t('AbpUi::DefaultErrorMessage');
  }

  return t('AbpUi::DefaultErrorMessage');
};

type AbpErrorResponse = {
  error: {
    code: string;
    message: string;
    details: string;
    data: Record<string, unknown>;
    validationErrors: unknown;
  };
};
